import { useFeature } from 'context/feature-flags';
import { useLocale } from 'hooks/useLocale';
import { useEffect, useRef, type PropsWithChildren } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { trackCaptchaPresence } from 'utils/dataLayers';

const reCaptchaKey = process.env.RECAPTCHA_KEY;

export function RecaptchaWrapper({ children, force = false }: PropsWithChildren<{ force?: boolean }>) {
  const captchaEnabled = useFeature('captchaEnabled');
  const { locale } = useLocale();
  const tracked = useRef(false);

  useEffect(() => {
    if (captchaEnabled === true && !tracked.current) {
      tracked.current = true;
      trackCaptchaPresence();
    }
  }, [captchaEnabled]);

  if (force || captchaEnabled === true) {
    return (
      <GoogleReCaptchaProvider
        reCaptchaKey={reCaptchaKey}
        language={locale}
        useRecaptchaNet
        scriptProps={{
          async: false,
          defer: false,
          appendTo: 'body',
          nonce: undefined,
        }}
      >
        {children}
      </GoogleReCaptchaProvider>
    );
  }
  return children;
}
